import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import getPromotedStrains from "api/requests/getPromotedStrains";
import { PromotedStrain } from "custom-types/Directus";

const StrainCarousel = dynamic(() => import("components/StrainCarousel"));

const ShopPromotedStrainsCarousel: React.FC = () => {
  const [strains, setStrains] = useState<PromotedStrain[]>();

  useEffect(() => {
    getPromotedStrains().then((strains) => setStrains(strains));
  }, []);

  if (strains === undefined || strains.length === 0) {
    return null;
  }

  return <StrainCarousel promotedStrains={strains} className="lg:mb-xl" />;
};

export default ShopPromotedStrainsCarousel;
